import { useTranslation } from 'react-i18next';
import SpeechBubble from '../../FirstAid/components/SpeechBubble/SpeechBubble';
import AskMascot from '../../../assets/kitoBuddy/Kito-Asking-Quick-Check-Wrong-Answer-1 1.png';
import CorrectAnswer from './CorrectAnswer';

export default function QuickCheck({
  title,
  question,
  answer,
  options,
  selectedAnswer,
  setSelectedAnswer,
  answerSubmitted,
  isCorrect,
  setAnswerSubmitted,
  wrongAnswer,
}) {
  const { t } = useTranslation();

  if (answerSubmitted && isCorrect) {
    return <CorrectAnswer answer={answer} />;
  }

  return (
    <div>
      <SpeechBubble
        mascot={AskMascot}
        text={answerSubmitted && !isCorrect ? t(wrongAnswer) : t(title)}
        bubbleoutline={answerSubmitted && !isCorrect ? 'red' : ''}
        bubbleBackgroundColor={answerSubmitted && !isCorrect ? 'red' : 'white'}
      />
      <div className="quiz__content">
        <p className="quiz__text">{t(question)}</p>
        <SelectAnswer
          options={options}
          selectedAnswer={selectedAnswer}
          setSelectedAnswer={setSelectedAnswer}
          answerSubmitted={answerSubmitted}
          isCorrect={isCorrect}
          setAnswerSubmitted={setAnswerSubmitted}
        />
      </div>
    </div>
  );
}

function SelectAnswer({ selectedAnswer, setSelectedAnswer, answerSubmitted, isCorrect, options, setAnswerSubmitted }) {
  const { t } = useTranslation();

  return (
    <div className="options">
      {options.map((option) => {
        const active = option.label === selectedAnswer?.label;

        return (
          <div
            key={option.label}
            className={`
              select__option
              ${active ? 'selected' : ''}
              ${answerSubmitted && active && !isCorrect ? 'wrong' : ''}
            `}
            onClick={() => {
              setSelectedAnswer(option);
              setAnswerSubmitted(false);
            }}
          >
            {t(option.label)}
          </div>
        );
      })}
    </div>
  );
}
